import store from 'redux/store';
import getAppInfo from './getAppInfo';
import { PostpeUserAPI } from 'containers/PostPaidFlow/Home2/services';
import { toast } from 'react-toastify';
import MESSAGE_CONSTANT from 'constants/msgConstant';
import { getURLParameter } from './getURLParameter';
import GLOBAL_CONSTANT from 'constants/globalConstant';

export const PostpeV1UserApi = async () => {
	try {
		const response = await PostpeUserAPI();
		console.log('RESPONSE', response);
		if (response) {
			return true;
		}
		return false;
	} catch (err) {
		toast.error(err?.message || MESSAGE_CONSTANT.SOMETHING_WRONG);
	}
};

export const isSuperAppHome = () => {
	if (getURLParameter('isSuperApp')) return getURLParameter('isSuperApp') === 'true';
	else if (getAppInfo()?.isSuperApp) return getAppInfo()?.isSuperApp === 'true';
	else return store.getState().generalDetails?.isSuperApp;
};
